import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "lpu_cards" } },
    _vm._l(_vm.lpus, function (lpu) {
      return _c(
        "div",
        {
          key: lpu.translit,
          staticClass:
            "d-flex flex-column align-center gr-4 pa-4 elevation-1 rounded",
          attrs: {
            "data-qa": "lpu_cards_item",
            "data-qa-translit": lpu.translit,
          },
        },
        [
          _setup.ff_update_lpu_logo
            ? _c(_setup.LpuLogoPicture, {
                attrs: {
                  "img-class": "flex-grow-0",
                  contain: "",
                  width: "240",
                  height: "80",
                  alt: "/",
                  files: lpu.logoFiles,
                },
              })
            : _c(VImg, {
                staticClass: "flex-grow-0",
                attrs: {
                  src: lpu.avatar,
                  "lazy-src":
                    "/static/_v1/pd/icons/ui-kit/photo/no-avatar-lpu.svg",
                  width: "240",
                  height: "80",
                  alt: "/",
                  contain: "",
                },
              }),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-column text-center gr-1" }, [
            _c(
              "a",
              {
                staticClass:
                  "text-subtitle-1 primary--text text-decoration-none",
                attrs: { "data-qa": "lpu_cards_item_url", href: lpu.url },
              },
              [_vm._v("\n        " + _vm._s(lpu.name) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "text-body-2 text-secondary--text",
                attrs: { "data-qa": "lpu_cards_item_town_name" },
              },
              [_vm._v("\n        " + _vm._s(lpu.townName) + "\n      ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_setup.t("Заблокирована до", _setup.options)) +
                  "\n        "
              ),
              _c(
                "span",
                {
                  attrs: { "data-qa": "lpu_cards_item_fraud_mark_expire_date" },
                },
                [_vm._v(_vm._s(lpu.fraudMarkExpireDate))]
              ),
            ]),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }